// Reverse-chronological career history. Stored as a feature list, so an item's
// language-neutral `icon` slot carries the years and the bilingual title/desc
// carry the role and what it involved — see PageContentRegistry's
// gisela-about-timeline entry.
export type TimelineItem = {
  icon?: string
  title_en?: string
  title_es?: string
  desc_en?: string
  desc_es?: string
}

export function CareerTimeline({ items, locale }: { items: TimelineItem[]; locale: string }) {
  const rows = items
    .map((item) => ({
      years: item.icon ?? "",
      role: (locale === "es" && item.title_es) || item.title_en || "",
      detail: (locale === "es" && item.desc_es) || item.desc_en || "",
    }))
    .filter((row) => row.role !== "")

  if (rows.length === 0) return null

  return (
    <ol className="m-0 list-none space-y-0 p-0">
      {rows.map((row, index) => (
        <li
          key={`${row.years}-${row.role}`}
          className={
            index === 0
              ? "grid grid-cols-1 gap-x-8 gap-y-1 py-6 sm:grid-cols-[minmax(0,9rem)_minmax(0,1fr)]"
              : "grid grid-cols-1 gap-x-8 gap-y-1 border-t border-hairline py-6 sm:grid-cols-[minmax(0,9rem)_minmax(0,1fr)]"
          }
        >
          {row.years && <p className="m-0 text-ink-muted">{row.years}</p>}
          <div className={row.years ? "" : "sm:col-start-2"}>
            <h3>{row.role}</h3>
            {row.detail && <p className="mt-1 mb-0 text-ink-body">{row.detail}</p>}
          </div>
        </li>
      ))}
    </ol>
  )
}
